<template>
  <el-button
    style="min-width: 150px"
    v-bind="$attrs"
    :disabled="disabled || innerDisabled"
    type="primary"
    @click="sendCode"
  >
    {{ text }}
  </el-button>
</template>

<script>
/**
 * 发送短信验证码倒计时组件
 *
 * 1、接收mobile属性，支持格式校验
 * 2、监听start事件，用于在父组件发起请求
 * 3、监听validate事件，用于在父组件校验手机号码
 * 4、支持el-button 一切属性
 *
 * 使用方式:
 * <SendCode size="small" :mobile="mobile" @start="sendCode"></SendCode>
 */
const INIT_TIME_SECODES = 60;
export default {
  inheritAttrs: false,
  props: {
    mobile: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timer: null,
      innerDisabled: false,
      seconds: INIT_TIME_SECODES,
      sendCount: 0 // 记录发送次数
    };
  },
  computed: {
    text() {
      return this.innerDisabled
        ? `${this.seconds}s后可重新发送`
        : this.sendCount >= 1
        ? "重新发送短信验证码"
        : "发送短信验证码";
    }
  },
  methods: {
    sendCode() {
      const mobileReg = new RegExp(/^1[3456789]\d{9}$/);
      //没有手机号，或者手机号码格式不正确
      if (!this.mobile || !mobileReg.test(this.mobile)) {
        this.$emit("validate");
        return;
      }
      this.$emit("start");
      this.innerDisabled = true;
      this.seconds = this.seconds - 1;
      this.sendCount++;
      this.timer = setInterval(() => {
        this.seconds--;
        if (this.seconds <= 0) {
          clearInterval(this.timer);
          this.timer = null;
          this.innerDisabled = false;
          this.seconds = INIT_TIME_SECODES;
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss"></style>
